import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
  CircularProgress,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { PlayArrow as PlayIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const PublicDiscTestInstructions = ({ testData, onStart, loading }) => {
  const { t } = useTranslation();

  const discStyles = [
    {
      letter: 'D',
      title: t('disc.dominance'),
      description: t('disc.dominanceDescription'),
      color: '#ffebee',
      textColor: '#c62828',
    },
    {
      letter: 'I',
      title: t('disc.influence'),
      description: t('disc.influenceDescription'),
      color: '#fff9c4',
      textColor: '#f57f17',
    },
    {
      letter: 'S',
      title: t('disc.steadiness'),
      description: t('disc.steadinessDescription'),
      color: '#e8f5e9',
      textColor: '#2e7d32',
    },
    {
      letter: 'C',
      title: t('disc.conscientiousness'),
      description: t('disc.conscientiousnessDescription'),
      color: '#e3f2fd',
      textColor: '#1565c0',
    },
  ];

  const instructions = [
    { number: 1, text: t('disc.instruction1') },
    { number: 2, text: t('disc.instruction2') },
    { number: 3, text: t('disc.instruction3') },
    { number: 4, text: t('disc.instruction4') },
    { number: 5, text: t('disc.instruction5') },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
            {t('disc.extendedDiscModel')}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            {t('disc.modelDescription')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t('disc.modelHistory')}
          </Typography>
        </Box>

        <Paper
          elevation={0}
          sx={{ bgcolor: 'grey.100', p: 3, mb: 4, borderRadius: 2 }}
        >
          <Typography
            variant="h5"
            gutterBottom
            sx={{ textAlign: 'center', fontWeight: 'bold', mb: 3 }}
          >
            {t('disc.testInstructions')}
          </Typography>

          {instructions.map((instruction) => (
            <Box
              key={instruction.number}
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                mb: 2,
              }}
            >
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  bgcolor: 'primary.main',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  flexShrink: 0,
                  mr: 2,
                }}
              >
                {instruction.number}
              </Box>
              <Typography variant="body1" sx={{ pt: 0.5 }}>
                {instruction.text}
              </Typography>
            </Box>
          ))}
        </Paper>

        <Box sx={{ textAlign: 'center' }}>
          <Button
            variant="contained"
            size="large"
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <PlayIcon />}
            onClick={onStart}
            disabled={loading}
            sx={{ px: 6, py: 1.5, fontSize: '1.1rem' }}
          >
            {loading ? t('disc.starting') : t('disc.startTest')}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default PublicDiscTestInstructions;